import React, { useState } from 'react'
import { Stack, Box, Alert, Heading, Text, Button, FormField, FileChooser } from '@/components/lib'

const Sponsor = ({ trial, fields, data, updateData }) => {
  const [logoUrl, setLogoUrl] = useState(trial?.sponsorLogoUrl)

  return (
    <Stack gap={5}>
      <Stack gap={5}>
        <Box>
          <Heading as='h3' size='md'>Trial sponsor</Heading>
          <Text>If this is set, the name of the trial sponsor will be displayed instead of the team name on the participant portal and app.</Text>
        </Box>

        <Box>
          {fields.map(field =>
            <FormField key={field.label} label={field.label} type={field.type} value={data[field.key]} onChange={e => updateData({ [field.key]: e.target.value })} />
          )}
        </Box>

        <Box>
          <Heading as='h4' size='sm'>Logo</Heading>
          <Text color='fg.muted'>Upload a logo for the trial sponsor. This logo will be shown to participants in place of the team's logo.</Text>
        </Box>
        {logoUrl
          ? <img src={logoUrl} style={{ width: 200 }} />
          : <Alert variant='left-accent'>No logo is currently set.</Alert>}
        <Stack direction='row'>
          <FileChooser
            accept='image/*'
            forType='trial' forObject={trial}
            onComplete={({ storedName, expectedUrl }) => {
              updateData({ sponsorLogo: storedName })
              setLogoUrl(expectedUrl)
            }}
            trigger={<Button colorPalette='primary' variant='outline'>Update logo</Button>}
          />
          <Button
            onClick={e => {
              updateData({ sponsorLogo: null })
              setLogoUrl(null)
            }}
          >Remove logo
          </Button>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default Sponsor
